<div class="text-xl text-gray-700 font-bold mb-4">Tipo Endereço</div>
<div>
  @if (checkPermission('criar')) {
    <mat-card class="card-style">
      <address-type-create (responseCreate)="uploadList('new')" />
    </mat-card>
  }
  <div class="mt-4">
    @if (checkPermission('visualizar')) {
      <form-search [search]="inputSearch" (responseSearch)="search($event)" />
    }
    @if (!loading) {
      <table-list-simple
        [dataSource]="itemsList"
        [columns]="columns"
        (selectItem)="editAddress($event)"
        (deleteItem)="deleteAddress($event)"
      />
      @if (itemsList.length > 0) {
        <mat-paginator
          [length]="numberRows"
          [pageSize]="rows"
          [pageIndex]="page - 1"
          [pageSizeOptions]="[5, 10, 20, 30]"
          (page)="onPageEvent($event)"
        >
        </mat-paginator>
      }
    } @else {
      <div>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
  </div>
</div>
